import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { TournamentManager } from '@/components/tournament/TournamentManager';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/hooks/use-language';

// Mock participants data for fallback
const mockParticipants = [
  {
    medlemsid: "1",
    fornavn: "John",
    etternavn: "Doe",
    mobil: "+47 12345678",
    epost: "john@example.com",
    bekreftelsestidspunkt: new Date().toISOString()
  },
  {
    medlemsid: "2",
    fornavn: "Jane",
    etternavn: "Smith",
    mobil: "+47 87654321",
    epost: "jane@example.com",
    bekreftelsestidspunkt: new Date().toISOString()
  },
  {
    medlemsid: "3",
    fornavn: "Mike",
    etternavn: "Johnson",
    mobil: "+47 11223344",
    epost: "mike@example.com",
    bekreftelsestidspunkt: new Date().toISOString()
  },
  {
    medlemsid: "4",
    fornavn: "Sarah",
    etternavn: "Wilson",
    mobil: "+47 55667788",
    epost: "sarah@example.com",
    bekreftelsestidspunkt: new Date().toISOString()
  }
];

export default function Tournaments() {
  const location = useLocation();
  const [participants, setParticipants] = useState(mockParticipants);
  const { t } = useLanguage();

  useEffect(() => {
    console.log('Tournaments page - location.state:', location.state);
    
    if (location.state?.participants) {
      console.log('Converting participant names:', location.state.participants);
      // Convert participant names to the format expected by TournamentManager
      const tournamentParticipants = location.state.participants.map((name: string, index: number) => {
        const [fornavn, ...etternavnParts] = name.split(' ');
        const etternavn = etternavnParts.join(' ');
        
        return {
          medlemsid: (index + 1).toString(),
          fornavn: fornavn || 'Unknown',
          etternavn: etternavn || 'Player',
          mobil: `+47 ${Math.floor(Math.random() * 90000000) + 10000000}`, // Generate random phone for now
          epost: `${fornavn?.toLowerCase() || 'player'}@example.com`,
          bekreftelsestidspunkt: new Date().toISOString()
        };
      });
      
      console.log('Converted tournament participants:', tournamentParticipants);
      setParticipants(tournamentParticipants);
    } else if (location.state?.participantDetails) {
      console.log('Converting participant details:', location.state.participantDetails);
      // If we have full participant details with phone numbers (preferred)
      const tournamentParticipants = location.state.participantDetails.map((participant: any, index: number) => {
        const [fornavn, ...etternavnParts] = participant.name.split(' ');
        const etternavn = etternavnParts.join(' ');
        
        return {
          medlemsid: participant.id || (index + 1).toString(),
          fornavn: fornavn || 'Unknown',
          etternavn: etternavn || 'Player',
          mobil: participant.phone || `+47 ${Math.floor(Math.random() * 90000000) + 10000000}`,
          epost: `${fornavn?.toLowerCase() || 'player'}@example.com`,
          bekreftelsestidspunkt: new Date().toISOString()
        };
      });
      
      console.log('Converted tournament participants from details:', tournamentParticipants);
      setParticipants(tournamentParticipants);
    }
  }, [location.state]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Tournaments</h1>
          <p className="text-muted-foreground mt-2">
            Manage and run tournaments for your groups
          </p>
          {(location.state?.participants || location.state?.participantDetails) && (
            <p className="text-sm text-green-600 mt-1">
              Tournament loaded with {location.state?.participants?.length || location.state?.participantDetails?.length || 0} participants from event
            </p>
          )}
        </div>
        <Button asChild variant="outline">
          <Link to="/past-tournaments">{t('tournament.past_tournaments')}</Link>
        </Button>
      </div>

      <TournamentManager 
        participants={participants} 
      />
      
    </div>
  );
}